<template>
  <div class="search">
    <button 
        class="d-inline-block bg-secondary rounded border-0 px-2 py-1"
        @click.stop="toggleVisible"
      >
      <b-icon class="text-body" icon="search" />
    </button>

    <div class="search-panel" v-if="isVisible" @click.stop>
      <div class="h4 text-center font-weight-bold mb-3">{{ panelTitle }}</div>

      <!-- 期間検索（複数可能） -->
      <div
        v-for="(period, index) in searchPeriods"
        :key="index"
        class="mb-4"
      >
        <label class="font-weight-bold mb-2" :for="'search-date-' + index">
          {{ period.label }}
        </label>
        <div class="w-100 d-flex">
          <div class="fd-admin-listproperty-card-filter filter-date w-50">
            <date-picker
              :name="'start-date-' + index"
              v-model="period.startDate"
              :config="period.datePickerOptions"
              autocomplete="off"
            ></date-picker>
          </div>
          <div class="my-auto px-2">
            <span class="text-center" style="font-size: 24px">~</span>
          </div>
          <div class="fd-admin-listproperty-card-filter filter-date w-50">
            <date-picker
              :name="'end-date-' + index"
              v-model="period.endDate"
              :config="period.datePickerOptions"
              autocomplete="off"
            ></date-picker>
          </div>
        </div>
      </div>
      <div class="text-center">
        <button class="btn btn-primary" @click="onSearch">検索</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PeriodSearchPanel',
    props: {
      panelTitle: {
        type: String,
        default: '詳細検索'
      },
      searchPeriods: {
        type: Array,
        default: () => ([
          {
            label: '最終更新日時検索',
            startDate: null,
            endDate: null,
            datePickerOptions: {}
          }
        ])
      }
    },

    data: () => ({
      isVisible: false
    }),

    mounted() {
      document.addEventListener('click', this.handleClickOutside);
    },

    beforeDestroy() {
      document.removeEventListener('click', this.handleClickOutside);
    },

    methods: {
      toggleVisible() {
        this.isVisible = !this.isVisible;
      },

      handleClickOutside(event) {
        // コンポーネントの要素内でない場合にパネルを閉じる
        if (!this.$el.contains(event.target)) {
          this.isVisible = false;
        }
      },

      onSearch() {
        this.$emit('search', this.searchPeriods);
        this.toggleVisible();
      }
    }
  };
</script>
